module.exports = "<p>idle-candidate works!</p>\n"